module.exports = __webpack_public_path__ + "img/pantalla-1-10.e44bd817.png";